import React from 'react';
import { observer } from '../../shared/observer';
import { runBusy, isBusy } from '../../shared/busy';

class SettingsView extends React.Component {
  state = {
    saving: false,
    saved: false,
    error: null,
    busy: {},
    pendingLang: null, // оптимистичное значение селекта языка на время запроса
  };

  componentWillMount() {
    const ci = this.props.auth.clientInfo || {};
    this.state = Object.assign({}, this.state, {
      mobile_first_name: ci.mobile_first_name || '',
      mobile_last_name: ci.mobile_last_name || '',
      mobile_middle_name: ci.mobile_middle_name || '',
      email: ci.email || '',
      birthday: ci.birthday || '',
    });
  }

  set = (k) => (e) => this.setState({ [k]: e.target.value, saved: false });

  save = async () => {
    if (this.state.saving) return;
    this.setState({ saving: true, error: null, saved: false });
    try {
      await this.props.auth.updateClientInfo({
        mobile_first_name: this.state.mobile_first_name,
        mobile_last_name: this.state.mobile_last_name,
        mobile_middle_name: this.state.mobile_middle_name,
        email: this.state.email,
        birthday: this.state.birthday,
      });
      this.setState({ saving: false, saved: true });
    } catch (e) {
      this.setState({ saving: false, error: e.message || 'Не сохранилось' });
    }
  };

  setLang = (e) => {
    if (isBusy(this, 'lang')) return;
    const lang = e.target.value;
    this.setState({ error: null, pendingLang: lang });
    runBusy(this, 'lang', () => this.props.auth.setLang(lang))
      .then(() => this.setState({ pendingLang: null }))
      .catch((err) => this.setState({ pendingLang: null, error: err.message || 'Не удалось сменить язык' }));
  };

  field(label, k, type) {
    return (
      <div className="input">
        <label>{label}</label>
        <input
          className="input__text"
          type={type || 'text'}
          value={this.state[k]}
          onChange={this.set(k)}
          disabled={this.state.saving}
        />
      </div>
    );
  }

  render() {
    const company = this.props.auth.companyInfo;
    const requireName = company.mobile_client_name_required || 'first_only';
    const showLast = requireName !== 'first_only';
    // «Фамилия и Имя» — отчество по желанию, поле есть, как в приложении
    const showMiddle = requireName !== 'first_only';
    const collectEmail = (company.mobile_client_email || 'collect') !== 'not_collect';
    const collectBirthday = (company.mobile_client_birthday || 'not_collect') !== 'not_collect';
    const lang = this.props.auth.mobileToken.lang_json && this.props.auth.mobileToken.lang_json.lang;

    return (
      <div>
        <h1>Настройки</h1>

        <section className="ng-checkout__section">
          {this.field('Имя', 'mobile_first_name')}
          {showLast && this.field('Фамилия', 'mobile_last_name')}
          {showMiddle && this.field('Отчество', 'mobile_middle_name')}
          {collectEmail && this.field(company.mobile_email_title || 'Email', 'email', 'email')}
          {collectBirthday && this.field('Дата рождения', 'birthday', 'date')}
        </section>

        {lang && (
          <section className="ng-checkout__section">
            <label>Язык</label>
            {isBusy(this, 'lang') && <span className="ng-loading-hint">Сохраняем…</span>}
            <select
              className="input__text"
              value={this.state.pendingLang || lang}
              onChange={this.setLang}
              disabled={isBusy(this, 'lang') || this.state.saving}
            >
              <option value="ru">Русский</option>
              <option value="ua">Українська</option>
              <option value="en">English</option>
            </select>
          </section>
        )}

        {this.state.error && <div className="order-message">{this.state.error}</div>}
        {this.state.saved && <div className="order-message">Сохранено.</div>}

        <button type="button" className={'btn' + (this.state.saving ? ' is-busy' : '')} onClick={this.save} disabled={this.state.saving}>
          {this.state.saving ? 'Сохраняем…' : 'Сохранить'}
        </button>
      </div>
    );
  }
}

export const Settings = observer(SettingsView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Profile/Settings.jsx